import { useState, useEffect, useContext } from "react"
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import { useForm, FormProvider, useFormContext, useFieldArray } from "react-hook-form"
import { Typography, toast } from "@stardust-ds/react"
import intl from "react-intl-universal"

import TrashIcon from "../../../assets/icons/TrashIcon"
import ColorPicker from "../../molecules/ColorPicker"
import Input from "../../atoms/Input"
import styles from "./index.module.scss"
import RcmpSelectWithIcons from "../../atoms/SelectIcon"
import DownArrow from "../../../assets/icons/DownArrow"
import PlusIcon from "../../../assets/icons/PlusIcon"
import RcmpActivityIcon from "../../atoms/ActivityIcon"
import RcmpFormErrorMessage from "../../atoms/FormErrorMessage"
import RcmpTextArea from "../../atoms/TextArea"
import Label from "../../atoms/Label"
import RcmpModalAdd from "../ModalAdd"
import RcmpSimpleSwitch from "../../atoms/SimpleSwitch"
import RcmpModalInfo from "../../organisms/ModalInfo"
import Tabs from "../../molecules/Tabs"
import RcmpHistory from "../History"
import EditIcon from "../../../assets/icons/EditIcon"
import ClockRotateIcon from "../../../assets/icons/ClockRotateIcon"
import FieldsContext from "../../../contexts/Fields"
import { NumericFormat } from "react-number-format"
import RcmpCheckBox from "../../atoms/Checkbox"
import RcmpArrowRightSingleAccordion from "../../../assets/icons/ArrowRightSingleAccordion"
import RcmpArrowDownSingleAccordion from "../../../assets/icons/ArrowDownSingleAccordion"



function RcmpSelectFieldNumberType(props) {
  const { register, watch } = useFormContext()
  const { setType, bIsEdit } = props
  const cType = watch("ctype")
  useEffect(() => {
    if (!cType) return
  }, [cType])
  return (
    <div className={styles.radioContainer}>
      <Label>Configurar o campo como:</Label>
      <div className={styles.radioContainer__row}>
        <div>
          <input
            type="radio"
            id="number"
            name="ctype"
            value="number"
            disabled={bIsEdit}
           
            {...register("ctype")}
          />
          <label
            className={bIsEdit ? styles.disabled_label : styles.label}
            htmlFor="number"
          >
            Número
          </label>
        </div>
        <div>
          <input
            type="radio"
            id="range"
            name="ctype"
            value="range"
            disabled={bIsEdit}
            {...register("ctype")}
          />
          <label
            className={bIsEdit ? styles.disabled_label : styles.label}
            htmlFor="range"
          >
            Faixa de Números
          </label>
        </div>
        <div>
          <input
            type="radio"
            id="calc"
            name="ctype"
            value="calc"
            disabled={bIsEdit}
            {...register("ctype")}
          />
          <label
            className={bIsEdit ? styles.disabled_label : styles.label}
            htmlFor="calc"
          >
            Cálculo Matemático
          </label>
        </div>
      </div>
    </div>
  )
}

function RcmpCreateFieldNumber(props) {
  const { oField } = props

  const [cStamp, fnSetCStamp] = useState(null)
  const [cTag, fnSetCTag] = useState("")

  const {
    register,
    setValue,
    getValues,
    watch,
    resetField,
    formState: { errors },
  } = useFormContext()

  const nValueView = 1000
  const cPrecisionField = "nprecision"

  useEffect(() => {
    return () => {
      setValue("cprefix", undefined, { shouldValidate: true })
      setValue("csuffix", undefined, { shouldValidate: true })
      resetField(cPrecisionField)
    }
  }, [])

  useEffect(() => {
    if (!cStamp) {
      setValue("cprefix", cTag, { shouldValidate: true })
      setValue("csuffix", "", { shouldValidate: true })
      return
    }

    setValue("cprefix", "", { shouldValidate: true })
    setValue("csuffix", cTag, { shouldValidate: true })
  }, [cTag, cStamp])

  useEffect(() => {
    if (!oField) return

    setValue(cPrecisionField, oField?.opfd_nprecision)
    if (oField?.opfd_cprefix) {
      fnSetCStamp(false)
      fnSetCTag(oField.opfd_cprefix)
      setValue("cprefix", oField.opfd_cprefix)
      return
    }

    if (oField?.opfd_csuffix) {
      fnSetCStamp(true)
      fnSetCTag(oField.opfd_csuffix)
      setValue("csuffix", oField.opfd_cprefix)
    }
  }, [oField])

  function fnDecrementDecimals() {
    if (getValues(cPrecisionField) - 1 < 0) return
    setValue(cPrecisionField, Number(Number(getValues(cPrecisionField) - 1)), {
      shouldValidate: true,
    })
  }

  function fnIncreaseDecimals() {
    setValue(cPrecisionField, Number(Number(getValues(cPrecisionField)) + 1))
  }

  function fnHandleAffixChange(bChecked) {
    fnSetCStamp(bChecked)
  }

  function fnHandleTagChange(e) {
    const cTag = e?.target?.value
    fnSetCTag(cTag)
  }

  const nPrecision = Number.isInteger(Number(watch(cPrecisionField)))
    ? watch(cPrecisionField) > 9
      ? 9
      : watch(cPrecisionField) < 0
      ? 0
      : watch(cPrecisionField)
    : 0

  return (
    <div className={styles.textFieldContainer}>
      <div className={styles.numberRow}>
        <div className={styles.affix}>
          <Input
            label={intl.get("fields.tag")}
            placeholder={intl.get("type")}
            onChange={fnHandleTagChange}
            value={cTag}
            disabled={oField}
          />
          <RcmpFormErrorMessage>
            {errors?.cprefix?.message || errors?.csuffix?.message}
          </RcmpFormErrorMessage>
        </div>
        {
          <div className={styles.switchAffix}>
            <RcmpSimpleSwitch
              cDisabledText={intl.get("fields.prefix")}
              cAbleText={intl.get("fields.sufix")}
              onChange={fnHandleAffixChange}
              value={cStamp}
            />
          </div>
        }
        <div className={styles.decimals}>
          <Label>{intl.get("fields.decimals")}</Label>
          <input
            {...register("nprecision")}
            defaultValue={watch("nprecision", 0)}
            value={watch("nprecision", 0)}
          />
          <div className={styles.arrowsInputContainer}>
            <DownArrow
              fill={"#6CB6E3"}
              style={{ transform: "rotate(180deg)" }}
              onClick={fnIncreaseDecimals}
            />
            <DownArrow fill={"#6CB6E3"} onClick={fnDecrementDecimals} />
          </div>
        </div>
        <div className={styles.view}>
          <Typography type="l3" color="rgb(65, 83, 100)">
            {intl.get("fields.view")}
          </Typography>
          <Typography type="p2">
            {!cStamp && <>{watch("cprefix")} </>}
            {nValueView?.toFixed(nPrecision)?.replace(".", ",")}
            {cStamp && <> {watch("csuffix")}</>}
          </Typography>
        </div>
        
      </div>
      {watch("ctype")?.toLowerCase() === "range" && (
        <div style={{ display: "flex", gap: "16px", justifyContent: "space-between" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            
            <Label>Limite Mínimo</Label>
            <NumericFormat 
               {...register("nmin_limit")}
               defaultValue={oField?.opfd_nmin_limit}
               onChange={(e) => {
                setValue("nmin_limit", e.target.value)
                
              }}
               
               decimalScale={nPrecision || 0}
               decimalSeparator=","
               fixedDecimalScale={nPrecision > 0 ? true : false}
               className={styles.limitInput}
               disabled={oField?.opfd_nid} 
               placeholder="Digite..."
            />
           
            <RcmpFormErrorMessage>{errors?.nmin_limit?.message}</RcmpFormErrorMessage>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <Label>Mínimo Ideal</Label>
            <NumericFormat 
              {...register("nmin_ideal")}
              defaultValue={oField?.opfd_nmin_ideal}
              onChange={(e) => setValue("nmin_ideal", e.target.value)}
              
              decimalScale={nPrecision || 0}
              decimalSeparator=","
              fixedDecimalScale={nPrecision > 0 ? true : false}
              className={styles.limitInput}
              placeholder="Digite..."
            />
          
            <RcmpFormErrorMessage>{errors?.nmin_ideal?.message}</RcmpFormErrorMessage>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <Label>Máximo Ideal</Label>
            <NumericFormat 
            {...register("nmax_ideal")}
            defaultValue={oField?.opfd_nmax_ideal}
            onChange={(e) => setValue("nmax_ideal", e.target.value)}
            
              decimalScale={nPrecision || 0}
              decimalSeparator=","
              fixedDecimalScale={nPrecision > 0 ? true : false}
              className={styles.limitInput}
              
              placeholder="Digite..."
            />
            <RcmpFormErrorMessage>{errors?.nmax_ideal?.message}</RcmpFormErrorMessage>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <Label>Limite Máximo</Label>
            <NumericFormat 
              {...register("nmax_limit")}
              defaultValue={oField?.opfd_nmax_limit}
              onChange={(e) => setValue("nmax_limit", e.target.value)}
              
              decimalScale={nPrecision || 0}
              decimalSeparator=","
              fixedDecimalScale={nPrecision > 0 ? true : false}
              className={styles.limitInput}
              disabled={oField?.opfd_nid}
              placeholder="Digite..."
            />
            <RcmpFormErrorMessage>{errors?.nmax_limit?.message}</RcmpFormErrorMessage>
          </div>
        </div>
      )}
      <RcmpFormErrorMessage textAlign="center">
        {errors?.nprecision?.message}
      </RcmpFormErrorMessage>
    </div>
  )
}

function RcmpCreateFieldSelection(props) {
  const { oField, bIsEdit } = props

  const {
    register,
    setValue,
    resetField,
    watch,
    formState: { errors },
  } = useFormContext()
  const { fields, append, remove } = useFieldArray({
    name: "aoptions",
  })
  const bCanCalculate = watch("bCanCalculate", false)

  const [bIsChecked, fnSetBIsChecked] = useState(false)
  const [bShowColorPick, fnSetBShowColorPick] = useState(false)
  const [cShowMessage, fnSetCShowMessage] = useState("")

  useEffect(() => {
    return () => {
      resetField("aoptions")
    }
  }, [])

  useEffect(() => {
    if (!oField) return
    setValue("bCanCalculate", oField.opfd_bcalculate)
    setValue("bCanChangeColor", oField.opfd_bchange_color)
    fnSetBIsChecked(oField?.opfd_bcalculate)
    fnSetBShowColorPick(oField?.opfd_bchange_color)
  }, [oField])
  useEffect(() => {
    if (!oField?.options.length) return

    for (const option of oField.options) {
      append({
        opfs_nid: option?.opfs_nid,
        cname: option?.opfs_coption_name,
        ccolor: option?.opfs_coption_color,
        bactive: option?.op_panel_active,
        cvalue: option?.opfs_coption_value,
      })
    }
  }, [oField])

  function fnAddField() {
    append({
      opfs_nid: undefined,
      cvalue: undefined,
      cname: "",
      ccolor: "#000000",
      bactive: true,
    })
  }

  function fnRemoveField(nIndex) {
    remove(nIndex)
  }

  return (
    <div className={styles.selectionFieldContainer}>
      <div className={styles.selectionContainer}>
        <div className={styles.selectionCheckContainer}>
          <AdvancedAccordeon>
            <div className={styles.AccordeonItems}>
              <RcmpCheckBox
                cLabel="Permitir Cálculo"
                checked={bIsChecked}
                disabled={bIsEdit}
                di
                onChange={(value) => {
                  fnSetBIsChecked(value.currentTarget.checked)
                  setValue("bCanCalculate", value.currentTarget.checked ? 1 : 0)
                }}
              />
              <Typography type="l3" color="#0066FF">
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    fnSetCShowMessage(
                      "Ao selecionar esta opção você pode definir valores numéricos (pesos) para cada uma das opções de seleção, permitindo que o campo seja utilizado em cálculos matemáticos. Desta forma, ao selecionar uma opção, no contexto de cálculo matemático, o sistema irá considerar o valor (peso) definido na configuração do campo.",
                    )
                  }
                >
                  O que é isso?
                </span>
              </Typography>
            </div>
            <div className={styles.AccordeonItems}>
              <RcmpCheckBox
                cLabel="Cores Customizadas por Item"
                disabled={bIsEdit}
                checked={bShowColorPick}
                onChange={(value) => {
                  fnSetBShowColorPick(value.currentTarget.checked)
                  setValue("bCanChangeColor", value.currentTarget.checked ? 1 : 0)
                }}
              />
              <Typography type="l3" color="#0066FF">
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    fnSetCShowMessage(
                      "Ao selecionar esta opção é possível definir a cor para cada opção selecionada. Desta forma, ao exibir o campo na listagem de atividades em um bloco, o texto da opção selecionada terá a cor definida.",
                    )
                  }
                >
                  O que é isso?
                </span>
              </Typography>
            </div>
          </AdvancedAccordeon>
        </div>
        <div className={styles.optionGridContainer}>
          <div className={styles.optionGridRow}>
            <Typography type="l3" color="#415364">
              {/* {intl.get("fields.items")} */}
              Itens
            </Typography>
            {bShowColorPick && (
              <Typography type="l3" color="#415364">
                {/* {intl.get("fields.items")} */}
                Cores
              </Typography>
            )}
            {bIsChecked && (
              <Typography type="l3" color="#415364">
                {/* {intl.get("fields.items")} */}
                Valor
              </Typography>
            )}
          </div>
          {fields?.map((item, i) => {
            const bCanEdit = watch(`aoptions[${i}].bactive`, true)

            return (
              <>
                <div key={item.id} className={styles.optionGridRow}>
                  <input
                    {...register(`aoptions[${i}].cname`)}
                    placeholder={`Item ${i + 1}...`}
                    className={styles.OptionGridInput}
                    disabled={item?.opfs_nid}
                  />
                  {bShowColorPick && (
                    <ColorPicker
                      value={item.ccolor}
                      disabled={!bCanEdit}
                      onChange={(cColor) => setValue(`aoptions[${i}].ccolor`, cColor)}
                    />
                  )}
                  {bIsChecked && (
                    <>
                      <input
                        {...register(`aoptions[${i}].cvalue`)}
                        className={styles.OptionGridInput}
                        disabled={item?.opfs_nid || !bCanCalculate || !bCanEdit}
                        placeholder={"000"}
                      />
                    </>
                  )}
                  <div className={styles.OptionGridDelete}>
                    {!item?.opfs_nid ? (
                      <TrashIcon fill="#FF3541" onClick={() => fnRemoveField(i)} />
                    ) : (
                      <span style={{ width: 18, display: "block" }}></span>
                    )}
                    {bIsEdit && item.opfs_nid && (
                      <RcmpSimpleSwitch
                        {...register(`aoptions[${i}].bactive`)}
                        cAbleText={watch(`aoptions[${i}].bactive`) ? "Ativo" : "Inativo"}
                        bShowActive
                        onChange={(bValue) => {
                          setValue(`aoptions[${i}].bactive`, bValue ? 1 : 0)
                        }}
                        value={watch(`aoptions[${i}].bactive`)}
                      />
                    )}
                  </div>
                </div>
                <RcmpFormErrorMessage>
                  {errors?.aoptions?.length > 0
                    ? errors.aoptions[i]?.cname?.message
                    : null}
                </RcmpFormErrorMessage>
                <RcmpFormErrorMessage>
                  {errors?.aoptions?.length > 0
                    ? errors.aoptions[i]?.cvalue?.message
                    : null}
                </RcmpFormErrorMessage>
              </>
            )
          })}
        </div>
        <div
          className={styles.addNewItemButton}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            fnAddField()
          }}
        >
          <PlusIcon fill={"#415364"} />
          <Typography type="l3" color="#415364">
            {intl.get("fields.add_item")}
          </Typography>
        </div>
      </div>
      <RcmpFormErrorMessage>{errors?.aoptions?.message}</RcmpFormErrorMessage>

      <RcmpModalInfo
        bIsOpen={cShowMessage}
        buttonCancelText={"Cancelar"}
        title="O que é isso?"
        size="sm"
        fnHandleCancel={() => fnSetCShowMessage("")}
        description={cShowMessage}
        onlyCancel
        onlyText
      />
    </div>
  )
}

export default function RcmpModalCreateNewCustomField(props) {
  const { bIsOpen, fnHandleConfirm, fnCancel, oCreateActivityFieldRes, bIsEdit, oField, bAddNewField = true } =
    props

  const [cFieldType, fnSetCFieldType] = useState("")
  const [bShowNumberType, fnSetBShowNumberType] = useState(false)
  const [bIsOpenConfirmEditFieldModal, fnSetBIsOpenConfirmEditFieldModal] =
    useState(false)
  const [nSelectedTab, fnSetnSelectedTab] = useState(0)
  const [bShowConfirmCancelModal, fnSetBShowConfirmCancelModal] = useState(false)

  const { oUpdateFieldRes } = useContext(FieldsContext)

  const oStaticValidations = yup.object().shape({
    cname: yup.string().required(intl.get("form.required_field")),
    ctype: yup.string().required(intl.get("form.required_field")),
    nmin_limit: yup.string().when("ctype", {
      is: (ctype) => {
        return ctype.toLowerCase() === "range"
       },
      then: yup.string('O limite mínimo deve ser um numero')
      .test('nmin_limit-is-number', "O limite mínimo deve ser um número", function (value) {
        if (!value) return true
        return !isNaN(value.replace(',', '.'))
      }).required(intl.get("form.required_field")),
      otherwise: yup.string().notRequired().nullable()
    }),
    nmin_ideal: yup.string().when("ctype", {
      is: (ctype) => {
        return ctype.toLowerCase() === "range"
       },
      then: yup
        .string()
        .required(intl.get("form.required_field"))
        .test('nmin_ideal-is-number', "O limite mínimo ideal deve ser um número", function (value) {
          if (!value) return true
          return !isNaN(value.replace(',', '.'))
        })
        .test(
          "nmin_ideal-gte-nmin_limit",
          "O limite mínimo ideal deve ser maior ou igual ao limite mínimo",
          function (value) {
            const { nmin_limit } = this.parent
            
            return Number(value?.replace(',', '.')) >= Number(nmin_limit?.replace(',','.'))
          },
        ),
        otherwise: yup.string().notRequired().nullable()
    }),

    nmax_ideal: yup.string().when("ctype", {
      is: (ctype) => {
        return ctype.toLowerCase() === "range"
       },
      then: yup
        .string('O limite máximo ideal deve ser um número')
        .required(intl.get("form.required_field"))
        .test('nmax_ideal-is-number', "O limite máximo ideal deve ser um número", function (value) {
          if (!value) return true
          return !isNaN(value.replace(',', '.'))
        })
        .test(
          "nmax_ideal-gt-nmin_ideal",
          "O limite máximo ideal deve ser maior que o limite mínimo ideal",
          function (value) {
            const { nmin_ideal } = this.parent
            return Number(value?.replace(',', '.')) > Number(nmin_ideal?.replace(',','.'))
          },
        ),
        otherwise: yup.string().notRequired().nullable()
    }),
    nmax_limit: yup.string().when("ctype", {
      is: (ctype) => {
        return ctype?.toLowerCase() === "range"
       },
      then: yup
        .string('O limite máximo deve ser um número')
        .required(intl.get("form.required_field"))
        .test('nmax_limit-is-number', "O limite máximo deve ser um número", function (value) {
          if (!value) return true
          return !isNaN(value.replace(',', '.'))
        })
        .test(
          "nmax_limit-gte-nmax_ideal",
          "O limite máximo deve ser maior ou igual ao limite máximo ideal",
          function (value) {
            const { nmax_ideal } = this.parent
            return Number(value?.replace(',', '.')) >= Number(nmax_ideal?.replace(',','.'))
          },
        ),
      otherwise: yup.string().notRequired().nullable()
    }),
    bCanCalculate: yup.mixed().transform((value, originalValue) => {
      if (originalValue === undefined) return 0
      return originalValue ? 1 : 0
    }),
    cprefix: yup.string().when(["ctype"], {
      is: (ctype) => {
        return ["number", "calc", "range"].includes(ctype.toLowerCase())
      },
      then: yup
        .string()
        .test(
          "not-empty",
          "O prefixo não aceita espaço em branco como caractere",
          (value) => {
            if (!value) return true
            return value.trim().length > 0
          },
        )
        .test("prefix", "O prefixo deve conter até 6 caracteres", (value) => {
          //se value for uma string vazia ou espaços em branco, retorna false
          if (value?.length > 6) return false
          return true
        }),
    }),
    csuffix: yup.string().when(["ctype"], {
      is: (ctype) => {
        return ["number", "calc", "range"].includes(ctype?.toLowerCase())
      },
      then: yup
        .string()
        .test(
          "not-empty",
          "O sufixo não aceita espaço em branco como caractere",
          (value) => {
            if (!value) return true
            return value.trim().length > 0
          },
        )
        .test("suffix", "O sufixo deve conter até 6 caracteres", (value) => {
          if (value?.length > 6) return false
          return true
        }),
    }),
    nprecision: yup
      .mixed()
      .transform((value, originalValue) => {
        //Verifica se o valor original tem uma virgula e troca por ponto

        if (originalValue === "") {
          // Se for uma string vazia, retorna 0.
          return 0
        }
        if (typeof originalValue === "string" && originalValue.includes(",")) {
          const newValue = Number(originalValue.replace(",", "."))
          if (isNaN(newValue)) {
            return 0
          }
          return newValue
        }
        // Se não for uma string vazia, tenta converter para número.
        const parsedValue = Number(originalValue)
        // Verifica se o valor convertido é NaN.
        if (isNaN(parsedValue)) {
          // Se for NaN, retorna 0.
          return 0
        }
        // Caso contrário, retorna o valor convertido para número.
        return parsedValue
      })
      .when(["ctype"], {
        is: (value) => ["NUMBER", "CALC", "RANGE"].includes(value?.toUpperCase()),
        then: yup
          .number("A quantidade de casas decimais deve ser um número positivo")
          .min(
            oField?.opfd_nprecision || 0,
            "A quantidade de casas decimais não pode ser menor que " +
              oField?.opfd_nprecision,
          )
          .max(9, "A quantidade de casas decimais não pode ser maior que 9")
          .integer("A quantidade de casas decimais deve ser um número inteiro"),
      }),
    aoptions: yup.array().when(["ctype"], {
      is: (value) => value === "selection",
      then: yup
        .array()
        .of(
          yup.object().shape({
            cname: yup.string().required(intl.get("form.required_field")),
          }),
        )
        .min(1, intl.get("fields.form.select_item"))
        .required(intl.get("fields.form.select_item"))
        .test("check-min-active", "Deve haver pelo menos um item ativo", (value) => {
          if (!value) return false
          return value.filter((item) => item.bactive).length > 0
        }),
    }),
  })

  const useFormMethods = useForm({
    criteriaMode: "all",
    resolver: yupResolver(oStaticValidations),
  })

  const {
    register,
    handleSubmit,
    setValue,
    setError,
    reset,
    getValues,
    formState: { errors },
  } = useFormMethods

  useEffect(() => {
    if (!bIsOpen || !oField) {
      reset({})
      fnSetCFieldType("")
      fnSetnSelectedTab(0)
      return
    }

    if (oField) {
      reset({
        opfd_nid: oField?.opfd_nid,
        cname: oField?.opfd_cname,
        cdescription: oField?.opfd_cdescription,
        cvalue: oField?.opfs_coption_value,
        nmin_ideal: oField?.opfd_nmin_ideal,
        nmax_ideal: oField?.opfd_nmax_ideal,
        nmin_limit: oField?.opfd_nmin_limit,
        nmax_limit: oField?.opfd_nmax_limit
      })

      fnHandleOnChangeFieldType(oField.opfd_ctype.toLowerCase())
    }
  }, [bIsOpen, oField])

  useEffect(() => {
    if (oUpdateFieldRes.loading || !oUpdateFieldRes.done) return

    if (oUpdateFieldRes.error) {
      toast({
        type: "error",
        description: intl.get("fields.edit_field_fail"),
      })
      return
    }

    // close modal on success
    reset({})
    fnSetCFieldType("")
    fnSetBShowNumberType(false)
    fnHandleCancelConfirmEditModal()
    fnCancel?.()
  }, [oUpdateFieldRes])

  if (!bIsOpen) return null

  const aSelectOption = [
    {
      label: intl.get("fields_type.text"),
      value: "text",
      icon: (
        <RcmpActivityIcon cType={"text"} fill={"#415364"} width={"16"} height={"16"} />
      ),
    },
    {
      label: intl.get("fields_type.number"),
      value: "unselected_number",
      icon: (
        <RcmpActivityIcon cType={"number"} fill={"#415364"} width={"16"} height={"16"} />
      ),
    },
    {
      label: intl.get("fields_type.selection"),
      value: "selection",
      icon: (
        <RcmpActivityIcon
          cType={"selection"}
          fill={"#415364"}
          width={"16"}
          height={"16"}
        />
      ),
    },
    {
      label: intl.get("fields_type.date"),
      value: "date",
      icon: (
        <RcmpActivityIcon cType={"date"} fill={"#415364"} width={"16"} height={"16"} />
      ),
    },
    {
      label: intl.get("fields_type.people"),
      value: "peoples",
      icon: (
        <RcmpActivityIcon cType={"peoples"} fill={"#415364"} width={"16"} height={"16"} />
      ),
    },
  ]

  function fnHandleOnChangeFieldType(cFieldType) {
    if (cFieldType === "number" || cFieldType === "calc" || cFieldType === "range") {
      setValue("ctype", cFieldType)
      fnSetBShowNumberType(true)
      fnSetCFieldType("unselected_number")
      return
    }
    if (cFieldType === "unselected_number") {
      setValue("ctype", '')
      fnSetBShowNumberType(true)
      fnSetCFieldType(cFieldType)
      return
    } else {
      fnSetBShowNumberType(false)
      fnSetCFieldType(cFieldType)
      setValue("ctype", cFieldType)
    }

    fnSetCFieldType(cFieldType)
    setValue("ctype", cFieldType)
  }

  async function fnHandleSubmit(oData) {
    const payload = oData
    payload.ctype = payload.ctype?.toUpperCase()


    if (payload.bCanCalculate) {
      let haveError = false
      payload.aoptions.map((item, i) => {
        if (!item.cvalue) {
          haveError = true
          setError(
            "aoptions[" + i + "].cvalue",
            {
              type: "required",
              message: intl.get("form.required_field"),
            },
            { shouldFocus: true },
          )
        }
        if (item.cvalue && isNaN(Number(item.cvalue.replace(",", ".")))) {
          haveError = true
          setError(
            "aoptions[" + i + "].cvalue",
            {
              type: "typeError",
              message: "Digite um valor numérico",
            },
            { shouldFocus: true },
          )
        }
        // o cvalue deve ter no máximo 9 caracteres
        if (item.cvalue && item.cvalue.length > 9) {
          haveError = true
          setError(
            "aoptions[" + i + "].cvalue",
            {
              type: "maxLength",
              message: "O valor deve ter no máximo 9 caracteres",
            },
            { shouldFocus: true },
          )
        }
      })
      if (haveError) return
    }

    if (bIsEdit) {
      fnSetBIsOpenConfirmEditFieldModal(true)
      return
    }



    const response = await fnHandleConfirm?.(payload)
   
    // reset({
    //   ctype: ''
    // })
    // fnSetCFieldType("")
  }

  function fnHandleCancel() {
    if (cFieldType === "" || bIsEdit) {
      fnCancel?.()
      return
    }

    fnSetCFieldType("")
    fnSetBShowNumberType(false)
    // setValue("ctype", "")
    reset({})
  }

  function fnHandleCancelWithButton() {
    const field = getValues()
    if (
      field.cname ||
      field.ctype ||
      field.cdescription ||
      field.nprecision ||
      field.cprefix ||
      field.csuffix ||
      field.aoptions
    ) {
      fnSetBShowConfirmCancelModal(true)
      return
    }
    fnHandleCancel()
  }

  async function fnHandleSubmitEditField() {
    try {
      const values = getValues()
      await fnHandleConfirm?.(values)
      fnCancel()
      fnHandleCancelConfirmEditModal()
    } catch (error) {
      console.log(error)
    }
  }

  function fnHandleCancelConfirmEditModal() {
    fnSetBIsOpenConfirmEditFieldModal(false)
  }

  function fnOnSelectTab(tab) {
    fnSetnSelectedTab(tab)
  }

  

  const bError = oCreateActivityFieldRes.error
  const bIsLoading = oCreateActivityFieldRes.loading
/*   useState(() => {
    console.log('erro: ', bError)
  }, [bError]) */
  const cButtonCancelText =
    cFieldType === "" || bIsEdit ? intl.get("cancel") : intl.get("back")

  // hide footer buttons at custom field history tab
  const hiddenFooterButtons = Boolean(bIsEdit && nSelectedTab === 1)
  const bCanShowDescription =
    cFieldType === "unselected_number" &&
    ["calc", "number", "range"].includes(useFormMethods.watch("ctype"))
  // form content
  function elCustomFieldForm() {
    return (
      <div className={styles.container}>
        <div className={styles.contentContainer}>
          <div className={styles.selectFieldType}>
            <RcmpSelectWithIcons
              data={aSelectOption}
              label={intl.get("fields.fild_type")}
              selected={cFieldType}
              onChange={fnHandleOnChangeFieldType}
              bDisabled={bIsEdit}
            />
            <RcmpFormErrorMessage>{errors?.ctype?.message}</RcmpFormErrorMessage>
          </div>
          <div>
            <Input
              isRequired
              isFullWidth
              label={intl.get("fields.field_name")}
              placeholder={intl.get("fields.field_name_placeholder")}
              {...register("cname")}
            />
            <RcmpFormErrorMessage>{errors?.cname?.message}</RcmpFormErrorMessage>
          </div>
        </div>
        <div className={styles.modalCreationArea}>
          {bShowNumberType && cFieldType === "unselected_number" && (
            <RcmpSelectFieldNumberType setType={fnSetCFieldType} bIsEdit={bIsEdit} />
          )}
          {["NUMBER", "CALC", "RANGE"].includes(useFormMethods.watch("ctype")?.toUpperCase()) &&
            cFieldType === "unselected_number" && (
              <RcmpCreateFieldNumber oField={oField} />
            )}
          {cFieldType === "selection" && (
            <RcmpCreateFieldSelection oField={oField} bIsEdit={bIsEdit} />
          )}
        </div>

        {cFieldType?.length > 0 && useFormMethods.watch("ctype") !== null && (
          <div
            className={
              ["NUMBER", "CALC", "SELECTION", "RANGE"].includes(
                useFormMethods.watch("ctype")?.toUpperCase(),
              )
                ? styles.textFieldContainerWithoutSpace
                : styles.textFieldContainer
            }
          >
            <RcmpTextArea
              label={intl.get("fields.field_description")}
              placeholder={intl.get("fields.field_description_placeholder")}
              {...register("cdescription")}
            />
          </div>
        )}
        
      </div>
    )
  }

  return (
    <FormProvider {...useFormMethods}>
      <RcmpModalAdd
        isOpen={bIsOpen}
        fnHandleCancel={fnHandleCancel}
        handleSubmit={handleSubmit}
        fnCreate={fnHandleSubmit}
        title={!bIsEdit ? intl.get("fields.new_custom_field") : "Editar campo"}
        buttonCancelText={cButtonCancelText}
        buttonSaveText={intl.get("fields.save_field")}
        oButtonCancelProps={{
          iconLeft: cFieldType !== "" ? "arrowLeft" : null,
          disabled: bIsLoading,
          onClick: fnHandleCancelWithButton,
          style: hiddenFooterButtons ? { display: "none" } : {},
        }}
        oButtonSaveProps={{
          isLoading: bIsLoading,
          disabled: cFieldType === "",
          iconRight: "check",
          style: hiddenFooterButtons ? { display: "none" } : {},
        }}
        cAlertMessage={bError ? bError.response.data.message === "Já existe um campo com esse nome" ? "Já existe um campo com esse nome" : intl.get("fields.field_create_error") : ""}
      >
        
        {!bIsEdit && elCustomFieldForm()}

        {bIsEdit && (
          <Tabs onSelect={fnOnSelectTab}>
            <Tabs.TabList>
              <Tabs.Tab style={{ gap: "12px" }}>
                <EditIcon /> EDITAR
              </Tabs.Tab>
              <Tabs.Tab style={{ gap: "12px" }}>
                <ClockRotateIcon /> HISTÓRICO
              </Tabs.Tab>
            </Tabs.TabList>
            <Tabs.TabPanel>{elCustomFieldForm()}</Tabs.TabPanel>
            <Tabs.TabPanel>
              <RcmpHistory
                nTargetId={oField.opfd_nid}
                cTargetHistoryType="field"
                aHeaders={[
                  intl.get("fields.history.date"),
                  intl.get("fields.history.user"),
                  intl.get("fields.history.type"),
                  intl.get("fields.history.change"),
                ]}
                cException=""
                fnFormatTextHistory={(oData, action) => {
                  if (action === "created") return "O campo foi criado"

                  switch (oData.opht_cfield) {
                    case "opfd_cname":
                      return intl.get("custom_fields_history.cname", {
                        oldValue: oData.opht_cold_value,
                        newValue: oData.opht_cnew_value,
                      })

                    case "opfd_cdescription":
                      return intl.get("custom_fields_history.cdescription", {
                        oldValue: oData.opht_cold_value,
                        newValue: oData.opht_cnew_value,
                      })

                    case "opfd_nprecision":
                      return intl.get("custom_fields_history.nprecision", {
                        oldValue: oData.opht_cold_value,
                        newValue: oData.opht_cnew_value,
                      })

                    case "opfd_cprefix":
                      return intl.get("custom_fields_history.cpreffix", {
                        oldValue: oData.opht_cold_value,
                        newValue: oData.opht_cnew_value,
                      })

                    case "opfd_csuffix":
                      return intl.get("custom_fields_history.csuffix", {
                        oldValue: oData.opht_cold_value,
                        newValue: oData.opht_cnew_value,
                      })
                    case "opfs_coption_color":
                      return intl.get("custom_fields_history.ccolor", {
                        oldValue: oData.opht_cold_value,
                        newValue: oData.opht_cnew_value,
                      })

                    case "op_panel_active":
                      return oData.opht_cnew_value === "1"
                        ? intl.get("custom_fields_history.activation")
                        : intl.get("custom_fields_history.desactivation")

                    case "opfd_nmin_ideal":
                      return intl.get("custom_fields_history.range", {
                        oldValue: oData.opht_cold_value,
                        newValue: oData.opht_cnew_value,
                        field: intl.get("custom_fields_history.minIdeal" )
                      })
                    case "opfd_nmax_ideal":
                      return intl.get("custom_fields_history.range", {
                        oldValue: oData.opht_cold_value,
                        newValue: oData.opht_cnew_value,
                        field: intl.get("custom_fields_history.maxIdeal" )
                      })
                    case "opfs_nid":
                      return "Uma opção foi criada"
                    default:
                      return intl.get("custom_fields_history.default")
                  }
                }}
              />
            </Tabs.TabPanel>
          </Tabs>
        )}
      </RcmpModalAdd>
      <RcmpModalInfo
        bIsOpen={bShowConfirmCancelModal}
        buttonCancelText={intl.get("cancel")}
        buttonSaveText={"Prosseguir"}
        title="Atenção"
        description="Você tem certerio que deseja cancelar a edição do campo? Todas as alterações serão perdidas."
        size={"sm"}
        fnHandleCancel={() => fnSetBShowConfirmCancelModal(false)}
        fnHandleConfirm={() => {
          fnHandleCancel()
          fnSetBShowConfirmCancelModal(false)
        }}
      />
      <RcmpModalInfo
        bIsOpen={bIsOpenConfirmEditFieldModal}
        buttonCancelText={intl.get("cancel")}
        buttonSaveText={intl.get("save")}
        title={intl.get("fields.confirm_edit_field_title")}
        description={intl.get("fields.alert_edit_field")}
        size={"sm"}
        fnHandleCancel={fnHandleCancelConfirmEditModal}
        fnHandleConfirm={fnHandleSubmitEditField}
      />
    </FormProvider>
  )
}

function AdvancedAccordeon(props) {
  const [showChildren, fnSetShowChildren] = useState(true)
  return (
    <div style={{ width: "100%", marginBottom: "32px" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row-reverse",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "16px",
          color: "rgb(65, 83, 100)",
        }}
        onClick={() => fnSetShowChildren((prev) => !prev)}
      >
        {showChildren ? (
          <RcmpArrowDownSingleAccordion />
        ) : (
          <RcmpArrowRightSingleAccordion />
        )}
        <h5>Configurações Avançadas</h5>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "4px",
        }}
      >
        {showChildren && props.children}
      </div>
    </div>
  )
}
